"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemas = void 0;
var TextInput = __importStar(require("./TextInput/TextInput.schema"));
exports.schemas = {
    TextInput: TextInput,
};
var Page_schema_1 = require("./Page/Page.schema");
Object.defineProperty(exports, "pageDataSchema", { enumerable: true, get: function () { return Page_schema_1.pageDataSchema; } });
Object.defineProperty(exports, "pagePropertiesSchema", { enumerable: true, get: function () { return Page_schema_1.pagePropertiesSchema; } });
Object.defineProperty(exports, "basePageDataSchema", { enumerable: true, get: function () { return Page_schema_1.basePageDataSchema; } });
var Anchor_schema_1 = require("./Anchor/Anchor.schema");
Object.defineProperty(exports, "anchorDataSchema", { enumerable: true, get: function () { return Anchor_schema_1.anchorDataSchema; } });
__exportStar(require("../core"), exports);
//# sourceMappingURL=schemas.js.map